import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const useMerchantReviewReply = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    async ({ reviewId, reply }) => {
      const res = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/product/reviews/${reviewId}/reply`,
        { reply },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("merchantReviews");
      },
    }
  );
};

export default useMerchantReviewReply;
